function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import DriverStartDate from '../components/DriverStartDate.vue';
import { v4 as uuidv4 } from 'uuid';
const orderCalcStart = 1000;
export default {
  data() {
    return {
      groupEventHistory: [],
      mapGroupActions: {
        'group:move': 'move'
      },
      moveGroupXhr: null,
      availableGroupActions: [{
        title: 'Chauffeur koppelen',
        action: 'attach_driver',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g><rect fill="none" height="24" width="24"/></g><g><path d="M20,9V6h-2v3h-3v2h3v3h2v-3h3V9H20z M9,12c2.21,0,4-1.79,4-4c0-2.21-1.79-4-4-4S5,5.79,5,8C5,10.21,6.79,12,9,12z M9,6 c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2S7,9.1,7,8C7,6.9,7.9,6,9,6z M15.39,14.56C13.71,13.7,11.53,13,9,13c-2.53,0-4.71,0.7-6.39,1.56 C1.61,15.07,1,16.1,1,17.22V20h16v-2.78C17,16.1,16.39,15.07,15.39,14.56z M15,18H3v-0.78c0-0.38,0.2-0.72,0.52-0.88 C4.71,15.73,6.63,15,9,15c2.37,0,4.29,0.73,5.48,1.34C14.8,16.5,15,16.84,15,17.22V18z"/></g></svg>',
        visible: true,
        callback: () => {
          this.$refs.driverModal.open();
          return false;
        }
      }, {
        title: 'Chauffeur ontkoppelen',
        action: 'deattach_driver',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#FFFFFF"><g><rect fill="none" height="24" width="24"/></g><g><g><path d="M14,8c0-2.21-1.79-4-4-4C7.79,4,6,5.79,6,8c0,2.21,1.79,4,4,4C12.21,12,14,10.21,14,8z M12,8c0,1.1-0.9,2-2,2 c-1.1,0-2-0.9-2-2s0.9-2,2-2C11.1,6,12,6.9,12,8z"/><path d="M2,18v2h16v-2c0-2.66-5.33-4-8-4C7.33,14,2,15.34,2,18z M4,18c0.2-0.71,3.3-2,6-2c2.69,0,5.77,1.28,6,2H4z"/><rect height="2" width="6" x="17" y="10"/></g></g></svg>',
        visible: true,
        confirmable: true,
        callback: (action = null, initSelection = null) => {
          const selection = initSelection ? initSelection : this.getSelection('group');
          let newGroups = _.cloneDeep(this.groups);
          const data = [];
          selection.forEach(groupId => {
            newGroups = newGroups.map(group => {
              if (group.group.uuid === groupId) {
                group.driver = null;
                group.group.finalized_at = null;
                group.group.finalized_by = null;
                group.jobs[0].status_text_with_icon = null;
              }
              return group;
            });
            data.push({
              id: groupId,
              driver: null,
              time: null,
              date: this.date
            });
          });
          this.groups = newGroups;
          if (!initSelection) {
            const actionId = uuidv4();
            this.echoChannel.whisper('group:deattach_driver', {
              selection: selection
            });
            this.saving = true;
            this.$http.post('/plannen/driver?date=' + moment(this.date).format('YYYY-MM-DD') + '&actionId=' + actionId, data).then(response => {
              this.saving = false;
            });
          }
          setTimeout(() => {
            data.forEach(group => {
              this.updateGroupStatus(group.id);
            });
            this.closeTooltips();
          }, 500);
          return true;
        }
      }, {
        title: 'Starttijd wijzigen',
        action: 'change_startdate',
        component: DriverStartDate,
        icon: '<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#FFFFFF"><g><rect fill="none" height="24" width="24"/></g><g><g><path d="M11,8v5l4.25,2.52l0.77-1.28l-3.52-2.09V8H11z M21,10V3l-2.64,2.64C16.74,4.01,14.49,3,12,3c-4.97,0-9,4.03-9,9 s4.03,9,9,9s9-4.03,9-9h-2c0,3.86-3.14,7-7,7s-7-3.14-7-7s3.14-7,7-7c1.93,0,3.68,0.79,4.95,2.05L14,10H21z"/></g></g></svg>',
        visible: true,
        callback: (action = null, initSelection = null) => {
          const actionId = uuidv4();
          const selection = initSelection ? initSelection : this.getSelection('group');
          const data = [];
          let newGroups = _.cloneDeep(this.groups);
          selection.forEach(groupId => {
            newGroups = newGroups.map((group, index) => {
              if (group.group.uuid === groupId) {
                group.startTime = action.subAction;
                if (group.jobs.length > 0 && group.jobs[0].status_text_with_icon && group.jobs[0].status_text_with_icon.includes('Starttijd:')) {
                  group.jobs[0].status_text_with_icon = `<div><img src="/images/job_statuses/drop.svg" class=""><span>Starttijd: ${group.startTime}</span></div>`;
                }
                data.push({
                  id: groupId,
                  time: action.subAction,
                  date: this.date
                });
              }
              return group;
            });
          });
          this.groups = newGroups;
          if (!initSelection) {
            this.echoChannel.whisper('group:change_startdate', {
              selection: selection,
              startTime: action.subAction
            });
            this.saving = true;
            this.$http.post('/plannen/start-date?date=' + moment(this.date).format('YYYY-MM-DD') + '&actionId=' + actionId, data).then(response => {
              this.saving = false;
            });
          }
          data.forEach(group => {
            setTimeout(() => {
              this.updateGroupStatus(group.id);
            }, 500);
          });
          return true;
        }
      }, {
        title: 'Omlaag verplaatsen',
        action: 'move_down',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><rect fill="none" height="24" width="24"/><path d="M19,15l-1.41-1.41L13,18.17V2H11v16.17l-4.59-4.59L5,15l7,7L19,15z"/></svg>',
        visible: true,
        callback: (action = null, initSelection = null) => {
          const selection = initSelection ? initSelection : this.getSelection('group');
          const newGroups = _.cloneDeep(this.groups);
          for (let i = newGroups.length - 1; i >= 0; i--) {
            const group = newGroups[i];
            const nextGroup = newGroups[i + 1];
            const shouldMoveCurrentGroup = selection.includes(group.group.uuid);
            const canMoveGroup = i < newGroups.length - 1 && nextGroup && nextGroup.group.uuid !== 'plan' && !selection.includes(nextGroup.group.uuid);
            if (shouldMoveCurrentGroup && canMoveGroup) {
              newGroups.splice(i, 2, nextGroup, group);
            }
          }
          this.groups = newGroups.map(function (group, index) {
            group.group.order = orderCalcStart - index;
            return group;
          });
          if (!initSelection) {
            this.echoChannel.whisper('group:move_down', {
              selection: selection
            });
            this.saveGroupOrder();
          }
          return false;
        }
      }, {
        title: 'Omhoog verplaatsen',
        action: 'move_up',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><rect fill="none" height="24" width="24"/><path d="M5,9l1.41,1.41L11,5.83V22H13V5.83l4.59,4.59L19,9l-7-7L5,9z"/></svg>',
        visible: true,
        callback: (action = null, initSelection = null) => {
          const selection = initSelection ? initSelection : this.getSelection('group');
          const newGroups = _.cloneDeep(this.groups);
          for (let i = 0; i < newGroups.length; i++) {
            const group = newGroups[i];
            const previousGroup = newGroups[i - 1];
            const shouldMoveCurrentGroup = selection.includes(group.group.uuid);
            const canMoveGroup = i > 0 && previousGroup && !selection.includes(previousGroup.group.uuid);
            if (shouldMoveCurrentGroup && canMoveGroup) {
              newGroups.splice(i - 1, 2, group, previousGroup);
            }
          }
          this.groups = newGroups.map(function (group, index) {
            group.group.order = orderCalcStart - index;
            return group;
          });
          if (!initSelection) {
            this.echoChannel.whisper('group:move_up', {
              selection: selection
            });
            this.saveGroupOrder();
          }
          return false;
        }
      }, {
        title: 'Naar beneden verplaatsen',
        action: 'move_to_bottom',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#FFFFFF"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z"/></svg>',
        visible: true,
        callback: (action = null, initSelection = null) => {
          const selection = initSelection ? initSelection : this.getSelection('group');
          const originalGroups = _.cloneDeep(this.groups);
          const newGroupsStart = [];
          const newGroupsMiddle = [];
          const newGroupsEnd = [];
          if (originalGroups[originalGroups.length - 1] && originalGroups[originalGroups.length - 1].group && originalGroups[originalGroups.length - 1].group.uuid === 'plan') {
            newGroupsEnd.push(originalGroups.pop());
          }
          originalGroups.map(group => {
            if (selection.includes(group.group.uuid)) {
              newGroupsMiddle.push(group);
            } else {
              newGroupsStart.push(group);
            }
          });
          this.groups = [].concat(newGroupsStart, newGroupsMiddle, newGroupsEnd).map(function (group, index) {
            group.group.order = orderCalcStart - index;
            return group;
          });
          if (!initSelection) {
            this.echoChannel.whisper('group:move_to_bottom', {
              selection: selection
            });
            this.saveGroupOrder();
            setTimeout(() => {
              this.scrollToGroup(selection[0]);
            }, 100);
          }
          return true;
        }
      }, {
        title: 'Naar boven verplaatsen',
        action: 'move_to_top',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#FFFFFF"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z"/></svg>',
        visible: true,
        callback: (action = null, initSelection = null) => {
          const selection = initSelection ? initSelection : this.getSelection('group');
          const originalGroups = _.cloneDeep(this.groups);
          const newGroupsStart = [];
          const newGroupsMiddle = [];
          const newGroupsEnd = [];
          if (originalGroups[originalGroups.length - 1].group.uuid === 'plan') {
            newGroupsEnd.push(originalGroups.pop());
          }
          originalGroups.map(group => {
            if (selection.includes(group.group.uuid)) {
              newGroupsStart.push(group);
            } else {
              newGroupsMiddle.push(group);
            }
          });
          this.groups = [].concat(newGroupsStart, newGroupsMiddle, newGroupsEnd).map(function (group, index) {
            group.group.order = orderCalcStart - index;
            return group;
          });
          if (!initSelection) {
            this.echoChannel.whisper('group:move_to_top', {
              selection: selection
            });
            this.saveGroupOrder();
            setTimeout(() => {
              this.scrollToGroup(selection[0]);
            }, 100);
          }
          return true;
        }
      }, {
        title: 'Toewijzen aan hoofdgroep',
        action: 'assign_to_maingroup',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g><rect fill="none" height="24" width="24"/></g><g><path d="M20,6h-8l-2-2H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V8C22,6.9,21.1,6,20,6z M20,18H4V6h5.17l1.41,1.41 L11.17,8H20V18z M12.16,12H8v2h4.16l-1.59,1.59L11.99,17L16,13.01L11.99,9l-1.41,1.41L12.16,12z"/></g></svg>',
        items: [{
          id: 0,
          name: 'Checken'
        }, {
          id: 1,
          name: 'Normaal'
        }, {
          id: 2,
          name: 'Gaat goed'
        }, {
          id: 3,
          name: 'Afgerond'
        }, {
          id: 5,
          name: 'Doorplannen'
        }],
        callback: (action = null, initSelection = null) => {
          const actionId = uuidv4();
          let newGroups = _.cloneDeep(this.groups);
          const selection = initSelection ? initSelection : this.getSelection('group');
          const data = [];
          selection.forEach(groupId => {
            newGroups = newGroups.map(group => {
              if (group.group.uuid === groupId) {
                group.group.main_group_id = action.subAction.id;
                data.push({
                  id: groupId,
                  main_group_id: group.group.main_group_id,
                  date: this.date
                });
              }
              return group;
            });
          });
          this.groups = newGroups;
          if (!initSelection) {
            this.echoChannel.whisper('group:assign_to_maingroup', {
              selection: selection,
              main_group_id: action.subAction.id
            });
            this.saving = true;
            this.$http.post('/plannen/assign-to-maingroup?date=' + moment(this.date).format('YYYY-MM-DD') + '&actionId=' + actionId, data).then(response => {
              this.saving = false;
            });
          }
          setTimeout(() => {
            this.setSortable();
            data.forEach(group => {
              this.updateGroupStatus(group.id);
            });
          }, 1000);
          return true;
        }
      }, {
        title: 'Herladen',
        action: 'refresh',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24"><path d="M12.05 20.15q-3.4 0-5.8-2.363-2.4-2.362-2.4-5.712v-.2L2.35 13.4.9 11.925l4.1-4.1 4.1 4.1L7.65 13.4l-1.5-1.525v.175q0 2.425 1.713 4.125 1.712 1.7 4.187 1.7.65 0 1.288-.163.637-.162 1.262-.487l1.675 1.675q-.975.625-2.05.937-1.075.313-2.175.313ZM19 16.2l-4.1-4.125 1.45-1.45 1.525 1.5v-.15q0-2.425-1.725-4.125-1.725-1.7-4.2-1.7-.65 0-1.287.15-.638.15-1.263.475L7.725 5.1q1-.625 2.063-.925 1.062-.3 2.162-.3 3.4 0 5.8 2.35t2.4 5.725v.175l1.5-1.5 1.475 1.45Z"/></svg>',
        callback: async (action = null, initSelection = null) => {
          const selection = initSelection ? initSelection : this.getSelection('group');
          await this.asyncForEach(selection, async groupId => {
            await this.updateGroup(groupId);
          });
          return true;
        }
      }, {
        title: 'Definitief maken',
        action: 'finalize',
        type: 'success',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#FFFFFF"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"/></svg>',
        visible: true,
        confirmable: true,
        disabled: true,
        callback: (action = null, initSelection = null) => {
          const selection = initSelection ? initSelection : this.getSelection('group');
          const groupCount = selection.length;
          const actionId = uuidv4();
          const data = [];
          let newGroups = _.cloneDeep(this.groups);
          selection.forEach(groupId => {
            newGroups = newGroups.map(group => {
              if (group.group.uuid === groupId) {
                group.group.finalized_at = moment().format();
                group.group.finalized_by = this.user.name;
                group.group.main_group_id = 0;
                data.push({
                  id: groupId,
                  driver: group.driver.id,
                  date: this.date
                });
              }
              return group;
            });
          });
          this.groups = newGroups;
          if (!initSelection) {
            this.echoChannel.whisper('group:finalize', {
              selection: selection,
              startTime: action.subAction
            });
            this.saving = true;
            this.$http.post('/plannen/finalize?date=' + moment(this.date).format('YYYY-MM-DD') + '&actionId=' + actionId, data).then(response => {
              this.saving = false;
              if (groupCount === 1) {
                notify({
                  title: "Chauffeur ingepland",
                  text: "Chauffeur is definitief ingepland.",
                  type: 'success'
                });
              } else {
                notify({
                  title: "Chauffeurs ingepland",
                  text: `${groupCount} chauffeurs zijn definitief ingepland.`,
                  type: 'success'
                });
              }
            }, error => {
              notify({
                title: "Chauffeur(s) niet ingepland",
                text: error.data.errors,
                type: 'error'
              });
            });
          }
          return true;
        }
      }, {
        title: 'Verwijderen',
        action: 'remove',
        type: 'danger',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#FFFFFF"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z"/></svg>',
        visible: true,
        confirmable: true,
        callback: (action = null, initSelection = null) => {
          const actionId = uuidv4();
          const selection = initSelection ? initSelection : this.getSelection('group');
          const data = [];
          let newGroups = _.cloneDeep(this.groups);
          let jobs = [];
          selection.forEach(groupId => {
            newGroups = newGroups.filter(group => {
              if (group.group.uuid === groupId) {
                data.push({
                  id: groupId
                });
                jobs = [].concat(_toConsumableArray(jobs), _toConsumableArray(group.jobs)).filter((v, i, a) => a.findIndex(v2 => v2.id === v.id) === i);
                return false;
              }
              return true;
            });
            const lastGroup = newGroups.find(group => group.group.uuid === 'plan');
            lastGroup.jobs = [].concat(_toConsumableArray(lastGroup.jobs), _toConsumableArray(jobs)).filter((v, i, a) => a.findIndex(v2 => v2.id === v.id) === i);
          });
          this.groups = newGroups;
          if (!initSelection) {
            this.echoChannel.whisper('group:remove', {
              selection: selection
            });
            this.saving = true;
            this.$http.post('/plannen/delete-group?date= ' + moment(this.date).format('YYYY-MM-DD') + '&actionId= ' + actionId, data).then(response => {
              this.saving = false;
            });
            this.resetSelection();
          } else {
            this.selectedGroups = this.selectedGroups.filter(group => !selection.includes(group));
          }
          return true;
        }
      }]
    };
  },
  watch: {
    groupActions() {
      setTimeout(() => {
        $('[data-toggle="tooltip"]').tooltip();
      }, 100);
    }
  },
  computed: {
    groupActions() {
      let newGroups = _.cloneDeep(this.groups);
      const selectedGroups = newGroups.filter(group => {
        if (group && group.group && group.group.uuid) {
          return this.getSelection('group').includes(group.group.uuid);
        }
        return false;
      });
      const groupHasDriver = selectedGroups.some(group => {
        return group.driver !== null;
      });
      const groupWithoutDriver = selectedGroups.some(group => {
        return group.driver === null;
      });
      const groupFinalized = selectedGroups.some(group => {
        return group.group.finalized_at && group.group.finalized_at !== null;
      });
      const groupHasUngrouped = selectedGroups.some(group => {
        return group.group.uuid == null;
      });
      return this.availableGroupActions.map(action => {
        action.visible = true;
        if (groupHasDriver && action.action === 'attach_driver') {
          action.visible = false;
        } else if (!groupHasDriver && ['deattach_driver', 'change_startdate'].includes(action.action)) {
          action.visible = false;
        } else if (groupWithoutDriver && action.action === 'finalize') {
          action.visible = false;
        } else if (groupFinalized && action.action === 'finalize') {
          action.visible = false;
        } else if (groupHasUngrouped) {
          action.visible = false;
        }
        return action;
      });
    }
  },
  methods: {
    groupAction(action, actionData, data) {
      const groupAction = this.availableGroupActions.find(groupAction => {
        return groupAction.action === action;
      });
      groupAction.callback(actionData, data);
    },
    saveGroupOrder() {
      const data = this.groups.map(group => {
        return {
          id: group.group.uuid,
          order: group.group.order
        };
      }).filter(group => {
        return group.id !== 'plan';
      });
      this.saving = true;
      this.$http.post('/plannen/move-group?date= ' + moment(this.date).format('YYYY-MM-DD'), data, {
        before(request) {
          if (this.moveGroupXhr) {
            this.moveGroupXhr.abort();
          }
          this.moveGroupXhr = request;
        }
      }).then(response => {
        this.saving = false;
      });
    },
    whisperGroup(action, event) {
      this.groupEventHistory.push(event.actionId);
      this.echoChannel.whisper(action, event);
    },
    catchWhisperGroup(action, event) {
      this.groupEventHistory.push(event.actionId);
      this.jobAction(this.mapGroupActions[action], event, event.selection);
    },
    backupGroupWhisperAction(action, event) {
      const groupEventAlreadyFired = this.groupEventHistory.includes(event.actionId);
      if (!groupEventAlreadyFired) {
        this.catchWhisperGroup(action, event);
      }
    }
  }
};


// WEBPACK FOOTER //
// ./resources/js/components/plan/mixins/GroupActionsMixin.js